import React from 'react';
import { useSiteMetadata } from '../util/use-site-metadata';
import { useStrapiContext } from '../context/StrapiContext';

const Seo = ({
  title,
  description,
  main_img,
  type,
  pathname,
  keywords,
  children,
  noindex = false, // Add this new prop with a default value of false
}) => {
  const { siteUrl } = useSiteMetadata();

  const {
    metaTitle,
    metaDescription,
    keywords: defaultKeywords,
    // metaRobots,
    // metaViewport,
  } = useStrapiContext().strapiGlobal.globalSeo;

  //build the title
  const constructedTitle = title
    ? `${title} | ${metaTitle}`
    : `${metaDescription} | ${metaTitle}`;

  //build the image url
  const strapiUrl = `https://typical-courage-66f007be10.media.strapiapp.com`;

  const formatImageUrl = (url) => {
    return url.startsWith('/') ? `${strapiUrl}${url}` : url;
  };

  const imageUrl = main_img ? formatImageUrl(main_img) : ``;

  //build the meta tags
  const seo = {
    title: constructedTitle,
    description: description || metaDescription,
    image: imageUrl,
    url: `${siteUrl}${pathname || ``}`,
    type: `${type || `website`}`,
    keywords: `${keywords || defaultKeywords}`,
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Clarity Windows and Doors",
    "url": "https://claritywindows.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://claritywindows.com/static/7a84c58e1ace4e58143742376a44be9f/0480b/narrow_No_Bg_White_Text_765dcefac3.webp"
    },
    "description": "Clarity Windows and Doors provides high-quality window and door replacement services for homeowners in North Texas.",
    "telephone": "(972) 393 3991",
    "email": "info@claritydfw.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "800 Freeport Pkwy Suite #150",
      "addressLocality": "Coppell",
      "addressRegion": "TX",
      "postalCode": "75019",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "32.9555",
      "longitude": "-97.0150"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "08:00",
        "closes": "17:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/ClarityWindowsAndDoors/",
      "https://www.linkedin.com/company/clarity-windows-and-doors",
      "https://www.youtube.com/@claritywindowsanddoors1086",
      "https://www.instagram.com/claritywindowsanddoors/"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "451"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Chul Ahn"
        },
        "datePublished": "2025-04-14",
        "reviewBody": "Clarity Windows & Doors has done an exceptional job for us. The installation team, led by Arturo, did an outstanding job installing a custom door and over 30 windows throughout our entire house. Their attention to detail and craftsmanship exceeded our expectations—we were truly impressed by their precision and care. They made sure everything was clean and tidy when the work was completed. We couldn’t be happier with the entire experience.\n\nThe installation team was professional, knowledgeable, and meticulous in their work. I highly recommend them and have already shared their information with friends who are considering window replacements.\n\nOur sales representative, Kyle, was fantastic. He guided us through the entire process with patience and expertise, helping us choose the perfect windows and a custom door for our home.\n\nI highly recommend Clarity Windows & Doors without reservation.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Dan Sharp"
        },
        "datePublished": "2025-03-31",
        "reviewBody": "Made an appointment with the company, Kyle Stephens showed up as scheduled on time! He did an excellent job at his presentation of the product. Kyle answered all questions & explained the process of everything in a professional manor. He was easy to work with and we would recommend him.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Benita Bradford"
        },
        "datePublished": "2025-03-31",
        "reviewBody": "We highly recommend Clarity Windows. The whole process is very easy. Jon Craig visited and gave us a very reasonable estimate. He reviewed all of our windows and offered many good solutions. Cost was so reasonable that we replaced all 19 windows. Communication during the order process was excellent. Shantel kept us very informed of our window status and installation date. The installation crew consisted of Lalo, the foreman and Daniel, Carlos, and Ivan. All were excellent, professional, respectful of your time. The window install was great, and clean up excellent. They really overworked and finished all 19 windows in one day since heavy rain forecast for the next day. We couldn't be happier. We were referred to Clarity by a friend and are so glad we chose them over the high pressure sales company that kept sending us mailers. We recommend anyone looking for window replacements to contact them.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      }
    ],
    "@id": "https://claritywindows.com/#HomeAndConstructionBusiness"
  };

  return (
    <>
      <html lang="en" />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="og:url" content={seo.url} />
      <meta name="og:type" content={seo.type} />

      <meta name="og:site_name" content={`${metaTitle}`} />
      <meta name="og:title" content={seo.title} />
      <meta name="og:description" content={seo.description} />
      <meta name="og:image" content={seo.image} />

      <link rel="canonical" href={seo.url} />

      {/* Add the robots meta tag */}
      <meta
        name="robots"
        content={noindex ? 'noindex, nofollow' : 'index, follow'}
      />

      {/* Add JSON-LD Schema */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/*BODY*/}
      {children}
    </>
  );
};

export default Seo;
